import { pushEventAndTrack } from '../../../helpers/taggingSerializer'

const trackInteraction = () => {
  const event = {
    eventInfo: {
      eventName: 'installationLbPage',
      eventAction: 'Installation Quickview Lightbox'
    },
    attributes: {
      clickOrigin: 'pdp:installation'
    }
  }

  pushEventAndTrack(event)
}

export default trackInteraction
